<script setup lang="ts">
import { ref,reactive,onMounted,onBeforeUnmount } from 'vue'
import CustomList from "../../../compositions/CustomList.vue";
import ModalDialog from "../../../compositions/ModalDialog.vue";
import SearchBox from "../../../compositions/SearchBox.vue";
import NonMedicineEditComponent from "../../Common/NonMedicineEditComponent.vue";
import config from "../../../config.js";
import { errorAlert,confirmAlert } from "../../../plugins/alert";
import { getFieldValue } from "../../../plugins/utility";
import qs from 'qs';
import axios from '../../../plugins/axios.ts';
import HelpAction from '../../../compositions/HelpAction.vue';

const props = defineProps({
    apis:{
      type:Object,
      required:true,
    },
    placeHolder:{
        type:String,
        default: () => {
            return '';
        }
    }
})
const listRef = ref();
const searchWord = ref('');
const onSearchWordChange = (value) => {
  searchWord.value = value;
}
const onSearchWordEnter = (value) => {
  searchWord.value = value;
  listSearch();
}
const listSearch = (delay=0) => {
  optionFields.value.search_word = searchWord.value;
  listRef.value.resetItem(delay);
}
const optionFields = ref({
  'page_size' : 30,
  'search_word': searchWord.value,
});
const fields = ref([
  {field_name: '商品名', field_key: 'custom_product_name', width: '20%', align: 'text-left'},
  {field_name: '商品名(カナ)', field_key: 'custom_half_width_product_name', width: '20%', align: 'text-left'},
  {field_name: '包装単位コード', field_key: 'sales_packaging_unit_code', width: '20%', align: 'text-center'},
  {field_name: '', field_key: 'action', width: '20%', align: 'text-center'}
]);

const isEditDialog = ref(false);
const editIdentityId = ref(0);
const selectNonMedicineId = ref(0);
const showEditDialog = (nonMedicineId) => {
  selectNonMedicineId.value = nonMedicineId
  editIdentityId.value++;
  isEditDialog.value = true;
}
const closeEditDialog = () => {
  isEditDialog.value = false;
}
const submitEditDialog = (nonMedicine) => {
  isEditDialog.value = false;
  listSearch(config.LIST_DELAY);
}
</script>

<style scoped>
</style>
<template>
<div ref="element" class="relative">
  <div class="absolute top-2 left-2">
    <help-action
      help-key="non_medicine_help"
    ></help-action>
  </div>
  <div class="w-full flex items-center justify-end p-2 bg-gray-100 rounded">
      <div class="mb-2 mt-1">
        <search-box
          :search-word="searchWord"
          :on-change="onSearchWordChange"
          :on-enter="onSearchWordEnter"
          place-holder="商品名を入力"
      ></search-box>
      </div>
      <div>
        <a href="javascript:void(0)" @click="showEditDialog(0)" class="block text-black bg-amber-300 hover:bg-amber-400 focus:ring-4 focus:ring-amber-200 font-medium rounded-lg text-base px-5 py-3 w-full sm:w-auto text-center ml-2">商品追加</a>
      </div>
  </div>
  <div class="w-full">
      <custom-list
        ref="listRef"
        :table-fields="fields"
        :api-url="apis.non_medicine_list"
        :option-fields="optionFields"
        height="72vh"
      >
      <template v-slot:item="slotProps">
        <td v-for="(field,index) in fields" :style="'width:' + field.width" :class="field.align">
          <div v-if="field.field_key != 'action'" :class="field.align">
            {{ getFieldValue(slotProps.item,field.field_key) }}
          </div>
          <div v-else :class="field.align">
            <a href="javascript:void(0)" @click="showEditDialog(slotProps.item.id)"><i class="fa-regular fa-pen-to-square text-lg"></i></a>
          </div>
        </td>
      </template>
      </custom-list>
      <div></div>
  </div>
</div>
<modal-dialog
  :is-visible="isEditDialog"
  help-key="non_medicine_edit_help"
  width="60%"
  :close="closeEditDialog"
>
  <template v-slot:header>
    商品登録
  </template>
  <template v-slot:default>
  <div>
    <non-medicine-edit-component
      :apis="apis"
      :non-medicine-id="selectNonMedicineId"
      :identity-id="editIdentityId"
      :submit="submitEditDialog"
      :cancel="closeEditDialog"
    ></non-medicine-edit-component>
  </div>
  </template>
</modal-dialog>

</template>

